import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router';
import { registerSW } from 'virtual:pwa-register'

const app = createApp(App);
app.use(createPinia());
app.use(router);
app.mount('#app');

// Enregistre le service worker (met à jour automatiquement quand tu rebuild)
const updateSW = registerSW({
    swPath:      '/build/sw.js',
    manifestPath:'/build/manifest.webmanifest',
    scope:      '/',
    onRegistered(r) { console.log('SW enregistré :', r) },
    onNeedRefresh() {
        // nouvelle version dispo : on recharge la page pour appliquer le cache
        updateSW()       // active le nouveau SW
        window.location.reload()
    },
    onRegisterError(e) { console.error('Erreur enregistrement SW:', e) }
})
